<template>
	<div>
		<div class="banner-box1">
			<!-- <img src="@/assets/images/about_banner.png" alt="" width="100%" /> -->
		</div>
        <div style="padding: 20px 40px;">
            <div class="desc-box">
                <!-- <div class="desc-title" style="font-size: .72rem /* 36/50 */">公司简介</div> -->
                <div class="desc-img">

                    <div class="left">
                        <div class="desc-title">公司简介</div>

                        <div class="text">
                            深圳市极智数字科技有限公司（简称：极智数科）是一家AI驱动的建筑科技公司，公司依托超过百余个工程项目数字化交付的经验，结合AI、大数据、云计算等新一代信息技术，在智能设计、BIM报建交付、数字审查、数字协同、数字化交付研发多款产品与技术咨询服务体系，逐步形成工程建设项目数字化智能化的解决方案，为工程建设行业数字化转型赋能。
                        </div>
                         <div class="desc-title">实力研发</div>

                        <div class="text">
                            极智数科作为建筑行业的科技型企业，投入大量研发力量，研发了极智BIM智能设计软件、极智BIM云协同管理平台、极智BIMeta系列设计软件（快模、管综、管网设计、机电设计、报建交付、出图等模块）。未来，极智数科将通过BIM深化应用研究，将BIM技术普及应用于工程建设全生命周期中，真正实现工程建设全流程信息化；并以工程大数据为基础，利用先进的智能图形技术，结合互联网、物联网、云计算等新兴信息技术，为智慧城市建设提供服务。
                        </div>
                    <div class="right"></div>

                    </div>
                </div>
            </div>
			

        </div>
        <div class="show-img-box">

        </div>
		<img src="@/assets/images/about-show2.png" alt="" width="100%">
	</div>
</template>

<script>
export default {};
</script>

<style scoped lang="less">
.banner-box1 {
    height: calc(100vw / (1920 / 500) + 3rem);
    width: 100%;
    background: url("../../../assets/images/about_banner.png") center no-repeat;
    background-size: cover ;
    background-position: center; 
}
.desc-box {
	display: flex;
	flex-direction: column;
	align-items: center;
	.desc-title {
		color: #222222;
		font-weight: 700;
		font-size: .64rem /* 32/50 */;
		margin-top: 40px;
        margin-bottom: 20px;
	}
	.desc-img {
		.right {
			background: url("../../../assets/images/desc-img.png");
			height: 12rem /* 600/50 */;
			width: 100%;
		}
		.left {
			width: 100%;
			color: #3d3d3d;
			font-size: 14px;
			line-height: 22px;
		}
	}
}
.show-img-box {
    height:6rem /* 300/50 */;
    width: 100%;
    background: url("../../../assets/images/about-show.png")  no-repeat ;
    background-size: 100%   ;
    background-position: center; /* 显示图片中心区域 */
}
</style>
